// @ts-nocheck
// this file was patched by @terra

import { z } from 'zod';
import { ChatBotSourceSchema } from '../inputTypeSchemas/ChatBotSourceSchema'

/////////////////////////////////////////
// CONVERSATION SCHEMA
/////////////////////////////////////////

export const ConversationSchema = z.object({
  source: ChatBotSourceSchema.nullable(),
  id: z.string(),
  tenantId: z.string(),
  threadId: z.string(),
  userId: z.string(),
  createdAt: z.coerce.date(),
  updatedAt: z.coerce.date(),
  agentId: z.string(),
  description: z.string().nullable(),
  title: z.string().nullable(),
  targetId: z.string().nullable(),
  targetType: z.string().nullable(),
})

export type Conversation = z.infer<typeof ConversationSchema>

export default ConversationSchema;
